import React, { useState } from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
const activestatus = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const EmailConfig = () => {
  const {
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();

  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="mb-5">
      {/* <h5 className="table-title mb-3">Company Settings</h5> */}

      <div className="form-row row">
        <div className="col-md-4 mb-3">
          <Input
            name="emailConfigurations[0].smtpServer"
            type="text"
            placeholder="Server"
            className={`form-control ${
              errors?.emailConfigurations?.[0]?.smtpServer ? "is-invalid" : ""
            }`}
            label="Server"
            labelClassName="form-label"
            required={true}
            requiredMessage="Server is required"
            maxLength={100}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="emailConfigurations[0].smtpPort"
            type="number"
            placeholder="Port"
            className={`form-control ${
              errors?.emailConfigurations?.[0]?.smtpPort ? "is-invalid" : ""
            }`}
            label="Port"
            labelClassName="form-label"
            required={true}
            requiredMessage="Port is required"
            maxLength={4}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="emailConfigurations[0].senderEmail"
            type="text"
            placeholder="Sender Email"
            className={`form-control ${
              errors?.emailConfigurations?.[0]?.senderEmail ? "is-invalid" : ""
            }`}
            label="Sender Email"
            labelClassName="form-label"
            required={true}
            requiredMessage="Sender Email is required"
            maxLength={100}
          />
        </div>
        <div className="col-md-4 mb-3">
          <div className="pass-group form-floating">
            <Input
              name="emailConfigurations[0].senderPassword"
              type={showPassword ? "text" : "password"}
              placeholder="Sender Password"
              className={`form-control ${
                errors?.emailConfigurations?.[0]?.senderPassword
                  ? "is-invalid"
                  : ""
              }`}
              label="Sender Password"
              labelClassName="form-label"
              required={true}
              requiredMessage="Sender Password is required"
              maxLength={20}
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              className={`fas toggle-password ${
                showPassword ? "fa-eye" : "fa-eye-slash"
              }`}
            />
          </div>

          {/* <div className="pass-group form-floating">
            <input
              type={showPassword ? "text" : "password"}
              {...register("password", {
                required: "Please enter password",
              })}
              placeholder="*****"
              className={`form-control ${errors.password ? "is-invalid" : ""}`}
              required={
                getValues("userID") === "0" || getValues("userID") === 0
                  ? true
                  : false
              }
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              className={`fas toggle-password ${
                showPassword ? "fa-eye" : "fa-eye-slash"
              }`}
            />
            <label>Password</label>
            <div className="invalid-feedback">{errors.password?.message}</div>
          </div> */}
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`emailConfigurations[0].useSSL`}
            type="commonSelect"
            placeholder="Use SSL"
            className={`form-control ${
              errors?.emailConfigurations?.[0]?.useSSL ? "is-invalid" : ""
            }`}
            label="Use SSL"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Use SSL is required"
            onChange={(selectedOption) => {
              setValue("emailConfigurations[0].useSSL", selectedOption);
              trigger("emailConfigurations[0].useSSL");
            }}
            defaultValue={watch("emailConfigurations[0].useSSL")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="emailConfigurations[0].useTLS"
            type="commonSelect"
            placeholder="Use TLS"
            className={`form-control ${
              errors?.emailConfigurations?.[0]?.useTLS ? "is-invalid" : ""
            }`}
            label="Use TLS"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Use TLS is required"
            onChange={(selectedOption) => {
              setValue("emailConfigurations[0].useTLS", selectedOption);
              trigger("emailConfigurations[0].useTLS");
            }}
            defaultValue={watch("emailConfigurations[0].useTLS")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="emailConfigurations[0].isEnabled"
            type="commonSelect"
            placeholder="Is Enabled"
            className={`form-control ${
              errors?.emailConfigurations?.[0]?.isEnabled ? "is-invalid" : ""
            }`}
            label="Is Enabled"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Is Enabled is required"
            onChange={(selectedOption) => {
              setValue("emailConfigurations[0].isEnabled", selectedOption);
              trigger("emailConfigurations[0].isEnabled");
            }}
            defaultValue={watch("emailConfigurations[0].isEnabled")}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailConfig;
